
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

const CallForDestructionForm = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Logo */}
      <div className="mt-12 mb-6">
        <img 
          src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" 
          alt="iSPAI Logo" 
          className="h-16 cursor-pointer"
          onClick={() => navigate("/curt-channel")}
        />
      </div>

      {/* Title */}
      <h1 className="text-3xl font-bold text-black mb-8 text-center">
        iSPAI Call for Destruction (CfD)
      </h1>

      <div className="w-full max-w-4xl">
        {/* Purpose Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-semibold text-center mb-4">Purpose</h2>
            <p className="text-gray-700 leading-relaxed">
              This form facilitates the formal process for requesting the removal of content from the iSPAI platform. It serves as a 
              mechanism for maintaining the integrity, accuracy, and ethical standards of our knowledge ecosystem. Content may be 
              flagged for destruction if it violates intellectual property rights, contains factual inaccuracies, presents security 
              risks, or contradicts established ethical guidelines. This process ensures that the iSPAI platform remains a trusted, 
              reliable, and responsible source of information.
            </p>
          </CardContent>
        </Card>

        {/* Instructions Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-semibold text-center mb-4">Instructions</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold">1. Identify the Content</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Provide specific information about the content you are requesting to be removed, including its location, title, 
                  author, and any other identifying details.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">2. State the Reason for Destruction</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Clearly explain why this content should be removed (e.g., copyright violation, factual inaccuracy, security concern, 
                  ethical violation).
                </p>
              </div>

              <div>
                <h3 className="font-semibold">3. Provide Supporting Evidence</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Include any documentation, links, or references that support your request for content removal.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">4. Suggest Alternative Content (Optional)</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  If applicable, recommend replacement content or corrections that could address the issues identified.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Next Button */}
        <div className="flex justify-center mt-8">
          <Button 
            className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded"
            onClick={() => navigate("/call-for-destruction/functional-area")}
          >
            Next: Identify Content Issue Type
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CallForDestructionForm;
